<template>
    <el-dialog
      class="MobileTicketQRCodeDialog"
      title="" 
      :visible.sync="dialogVisible"
      top="10vh"
      width="90vw" 
      :before-close="handleClose">
      <img style="width:100%;heigth:100%;margin-top:-10px;" :src="'/ticket/ticket_qrcode_' + ticket.orderId"/>
    </el-dialog>
</template>

<script>
export default {
  name: "MobileTicketQRCodeDialog",

  data() {
    return {
        dialogVisible: false,
        ticket : {}
    };
  },

  methods: {
    show( _ticket ) {
        this.ticket = _ticket;
        this.dialogVisible = true;
    },

    //弹出层关闭-指派
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style>
.MobileTicketQRCodeDialog .el-dialog__headerbtn {
  right: 5px;
  top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile-ticket/MobileTicketQRCodeDialog.vue